<div class="input-group">
    <input class="form-control" [formControl]="control" [id]="id" [name]="id" [title]="title"
        [placeholder]="placeholder" [min]="minDate" [max]="maxDate" (dateChange)="dateChangeEvent($event)"
        [ngClass]="{'is-invalid':control.touched && control.invalid}" [matDatepickerFilter]="dayFilter"
        [matDatepicker]="picker">

    <button class="form-control " (click)="picker.open()"
        [ngClass]="{'data-required':control.touched && control.invalid}"
        style="border-radius: 0 0.185rem 0.185rem 0; width: 40px; max-width: 40px; padding: 7px;">

        <mat-icon class="text-primary pj-ico-150" style="max-height: 18px;">calendar_today</mat-icon>

        <mat-datepicker [startView]="startView" #picker></mat-datepicker>
    </button>
</div>

<small *ngIf="messageFooter" class="form-text text-muted">{{messageFooter}}</small>

<div class="invalid-feedback d-block" *ngIf="control !== undefined && control.touched && control.invalid">

    <div *ngIf="control.errors?.matDatepickerParse; else errorRequired">
        Favor ingrese un formato valido. Ej: 27/05/1991
    </div>

    <ng-template #errorRequired>
        <div *ngIf="control.errors?.required !== undefined; else errorInvalidDate">
            {{messageRequired}}
        </div>
    </ng-template>

    <ng-template #errorInvalidDate>

        <div *ngIf="control.errors?.invalidDate; else divinvalidMaxWord">

            <span *ngIf="control.errors?.invalidDate?.range">Seleccione una fecha entre
                {{control.errors?.invalidDate.range.min | date:'dd/MM/yyyy'}} y {{control.errors?.invalidDate.range.max
                | date:'dd/MM/yyyy'}}.</span>
            <span *ngIf="control.errors?.invalidDate?.minyear">La edad mínima para el registro es
                {{control.errors?.invalidDate.minyear.min}} años.</span>
            <span *ngIf="control.errors?.invalidDate?.maxyear">La edad máxima para el registro es
                {{control.errors?.invalidDate.maxyear.max}} años.</span>
            <span *ngIf="control.errors?.invalidDate?.mindate">Ingresa una fecha superior a
                {{control.errors?.invalidDate.mindate.min | date:'dd/MM/yyyy'}}</span>

        </div>
    </ng-template>

    <ng-template #nextTemplate>

    </ng-template>
</div>